module.exports = __webpack_public_path__ + "media/images/level_introduction3_sp-ca794b7b6f1a3e119a653ed1cea12db8.png";